import type { CSSProperties } from "react";

/** 股票详情页左右内边距（参考雪球约 16px） */
export const STOCK_DETAIL_PAGE_PADDING_X = 16;

/** 导航栏：股票名称字号（px） */
export const STOCK_DETAIL_NAV_NAME_FONT_SIZE = 16;

/** 导航栏：股票代码字号（px） */
export const STOCK_DETAIL_NAV_CODE_FONT_SIZE = 12;

/** 基本信息区：股价主字号（px） */
export const STOCK_DETAIL_QUOTE_FONT_SIZE = 28;

/** 基本信息区：涨跌幅字号（px），与股价同行底部对齐 */
export const STOCK_DETAIL_CHANGE_FONT_SIZE = 16;

/** 基本信息区：股价与涨跌幅间距（px） */
export const STOCK_DETAIL_QUOTE_GAP = 8;

/** 基本信息区：评分项字号（px） */
export const STOCK_DETAIL_SCORE_FONT_SIZE = 14;

/** 基本信息区：价格行与评分行间距（px） */
export const STOCK_DETAIL_QUOTE_TO_SCORE_GAP = 8;

/** 基本信息区：评分项间距（px） */
export const STOCK_DETAIL_SCORE_GAP = 24;

/** 基本信息区：评分行与 K 线区间距（px） */
export const STOCK_DETAIL_SCORE_TO_KLINE_GAP = 8;

/** K 线区与 Tab 区间距（px） */
export const STOCK_DETAIL_KLINE_TO_TABS_GAP = 4;

export function stockDetailPageCssVars(): CSSProperties {
  return {
    "--lf-stock-detail-padding-x": `${STOCK_DETAIL_PAGE_PADDING_X}px`,
    "--h5-sub-page-title-font-size": `${STOCK_DETAIL_NAV_NAME_FONT_SIZE}px`,
    "--h5-sub-page-title-sub-font-size": `${STOCK_DETAIL_NAV_CODE_FONT_SIZE}px`,
    "--lf-stock-detail-quote-font-size": `${STOCK_DETAIL_QUOTE_FONT_SIZE}px`,
    "--lf-stock-detail-change-font-size": `${STOCK_DETAIL_CHANGE_FONT_SIZE}px`,
    "--lf-stock-detail-quote-gap": `${STOCK_DETAIL_QUOTE_GAP}px`,
    "--lf-stock-detail-score-font-size": `${STOCK_DETAIL_SCORE_FONT_SIZE}px`,
    "--lf-stock-detail-quote-to-score-gap": `${STOCK_DETAIL_QUOTE_TO_SCORE_GAP}px`,
    "--lf-stock-detail-score-gap": `${STOCK_DETAIL_SCORE_GAP}px`,
    "--lf-stock-detail-score-to-kline-gap": `${STOCK_DETAIL_SCORE_TO_KLINE_GAP}px`,
    "--lf-stock-detail-kline-to-tabs-gap": `${STOCK_DETAIL_KLINE_TO_TABS_GAP}px`,
  } as CSSProperties;
}
